/* app-insights/assets/js/app-insights.js — the App Insights page (frontend/pages.php, data-ai="…" hooks).
 * Reads GET /plugin/app-insights/overview?site=&from=&to= and draws KPI tiles, the version-adoption timeline,
 * versions / OS / devices, launches and per-version stability. No chart library: plain HTML bars. */
(function () {
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["app-insights"] = "1.1.0"; } catch (e) {}

  var COLORS = ["#2A6FE8", "#16A34A", "#F59E0B", "#8B5CF6"], OTHER = "#CBD5E1";
  var KIND_COLORS = { install: "#16A34A", update: "#2A6FE8", open: "#C7D3E6" };

  function T(k, v) { return (window.GS && GS.t) ? GS.t(k, v) : k; }
  function $(k) { return document.querySelector('[data-ai="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function vcmp(a, b) {
    var x = String(a).split(/[.-]/), y = String(b).split(/[.-]/);
    for (var i = 0; i < Math.max(x.length, y.length); i++) {
      var p = parseInt(x[i] || "0", 10), q = parseInt(y[i] || "0", 10);
      if (isNaN(p) || isNaN(q)) { var c = String(x[i] || "").localeCompare(String(y[i] || "")); if (c) return c; continue; }
      if (p !== q) return p - q;
    }
    return 0;
  }
  function num(n) { return (+n || 0).toLocaleString(); }
  function pct(n, d) { return n == null ? "—" : (+n).toFixed(d == null ? 1 : d).replace(/\.0+$/, "") + "%"; }
  function secs(ms) { if (ms == null) return "—"; return ms < 1000 ? ms + " ms" : (ms / 1000).toFixed(ms < 10000 ? 2 : 1).replace(/0$/, "") + " s"; }
  function days(n) { return T(+n === 1 ? "appi.n_day" : "appi.n_days", { n: n }); }
  function ver(v) { return v === "?" ? T("appi.unknown") : (v === "other" ? T("appi.other") : "v" + v); }

  // ---------------------------------------------------------------- range picker (same as the other plugin pages)
  function ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function today() { var n = new Date(); return new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate())); }
  function preset(days) {
    var to = today(), from = new Date(to.getTime() - (days - 1) * 86400000);
    var lbl = { 7: T("an.last7"), 30: T("an.last30"), 90: T("an.last90"), 365: T("an.last12mo") }[days] || (days + " days");
    return { from: ymd(from), to: ymd(to), label: lbl, preset: String(days) };
  }
  var cur = preset(30);
  try {
    var saved = JSON.parse(localStorage.getItem("gs_appi_range") || "null");
    if (saved && saved.preset) cur = preset(+saved.preset);
    else if (saved && saved.from && saved.to) cur = { from: saved.from, to: saved.to, label: saved.from + " → " + saved.to, preset: null };
  } catch (e) {}

  function wireRange() {
    var btn = $("rangeBtn"), menu = $("rangeMenu"), lab = $("range-label");
    if (!btn || !menu || btn._w) return; btn._w = 1;
    if (lab) lab.textContent = cur.label;
    function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === cur.preset); }); }
    btn.addEventListener("click", function (e) {
      if (menu.contains(e.target)) return;
      e.stopPropagation();
      var open = menu.style.display !== "none";
      menu.style.display = open ? "none" : "block";
      if (!open) { menu.querySelector('[data-rp="from"]').value = cur.from; menu.querySelector('[data-rp="to"]').value = cur.to; sync(); }
    });
    document.addEventListener("click", function (e) { if (!btn.contains(e.target)) menu.style.display = "none"; });
    function apply(o) {
      cur = o; if (lab) lab.textContent = o.label; menu.style.display = "none";
      try { localStorage.setItem("gs_appi_range", JSON.stringify({ from: o.from, to: o.to, preset: o.preset })); } catch (e) {}
      load();
    }
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(preset(+b.getAttribute("data-preset"))); }); });
    menu.querySelector('[data-rp="apply"]').addEventListener("click", function () {
      var f = menu.querySelector('[data-rp="from"]').value, t = menu.querySelector('[data-rp="to"]').value;
      if (!f || !t) return; if (f > t) { var x = f; f = t; t = x; }
      apply({ from: f, to: t, label: f + " → " + t, preset: null });
    });
  }

  // ---------------------------------------------------------------- states
  function state(h, p) {
    var s = $("state"), b = $("body"); if (!s) return;
    $("state-h").textContent = h; $("state-p").textContent = p || "";
    s.hidden = false; if (b) b.hidden = true;
  }
  function currentSite() {
    try { return (GS.sites || []).filter(function (x) { return x.public_key === GS.site; })[0] || null; } catch (e) { return null; }
  }

  // ---------------------------------------------------------------- pieces
  function kpi(label, value, sub, note, tone) {
    return '<div class="col-6 col-lg-3"><div class="appi-kpi' + (tone ? " appi-" + tone : "") + '">' +
      '<div class="appi-kpi-l">' + esc(label) + "</div>" +
      '<div class="appi-kpi-v">' + value + "</div>" +
      (sub ? '<div class="appi-kpi-s">' + sub + "</div>" : "") +
      (note ? '<div class="appi-kpi-n">' + note + "</div>" : "") + "</div></div>";
  }
  function bars(rows, labelFn, max) {
    if (!rows || !rows.length) return '<div class="gs-muted small">' + esc(T("appi.none")) + "</div>";
    return '<div class="appi-bars">' + rows.slice(0, max || 8).map(function (r) {
      return '<div class="appi-bar-row"><div class="appi-bar-l" title="' + esc(labelFn(r)) + '">' + esc(labelFn(r)) + "</div>" +
        '<div class="appi-bar-t"><div class="appi-bar-f" style="width:' + Math.max(1, Math.min(100, +r.share || 0)) + '%"></div></div>' +
        '<div class="appi-bar-v">' + pct(r.share) + '<span class="gs-muted"> · ' + num(r.sessions) + "</span></div></div>";
    }).join("") + "</div>";
  }
  function stacked(days, keys, colorOf, valueOf, titleOf) {
    if (!days || !days.length) return '<div class="gs-muted small">' + esc(T("appi.none")) + "</div>";
    var max = 0;
    days.forEach(function (d) { var t = 0; keys.forEach(function (k) { t += +valueOf(d, k) || 0; }); max = Math.max(max, t); });
    var html = '<div class="appi-stack">' + days.map(function (d) {
      var t = 0; keys.forEach(function (k) { t += +valueOf(d, k) || 0; });
      var h = max ? t / max * 100 : 0;
      var segs = keys.map(function (k) {
        var v = +valueOf(d, k) || 0; if (!v) return "";
        return '<div style="flex:' + v + ";background:" + colorOf(k) + '"></div>';
      }).join("");
      return '<div class="appi-stack-col" title="' + esc(titleOf(d)) + '"><div class="appi-stack-bar" style="height:' + h + '%">' + segs + "</div></div>";
    }).join("") + "</div>";
    var first = days[0].day, last = days[days.length - 1].day;
    return html + '<div class="appi-axis"><span>' + esc(first) + "</span><span>" + esc(last) + "</span></div>";
  }
  function legend(keys, colorOf, labelOf) {
    return keys.map(function (k) { return '<span class="appi-lg"><i style="background:' + colorOf(k) + '"></i>' + esc(labelOf(k)) + "</span>"; }).join("");
  }
  function empty(msg) { return '<div class="appi-empty"><i class="bi bi-hourglass-split"></i><span>' + esc(msg) + "</span></div>"; }

  // ---------------------------------------------------------------- render
  function render(d) {
    $("state").hidden = true; $("body").hidden = false;
    var L = d.latest, st = d.stability || {}, la = d.launches || {}, bk = la.by_kind || {};

    // KPIs
    var k = "";
    if (L) {
      var adopt = L.days_to_90 != null ? T("appi.k_90_after", { n: days(L.days_to_90) }) : (L.days_to_50 != null ? T("appi.k_50_after", { n: days(L.days_to_50) }) : T("appi.k_not_50"));
      k += kpi(T("appi.k_latest"), esc(ver(L.version)), esc(T("appi.k_share7", { p: pct(L.share_7d) })),
               esc(T("appi.k_live", { n: L.days_live == null ? "—" : days(L.days_live) })) + " · " + esc(adopt));
    } else k += kpi(T("appi.k_latest"), "—", esc(T("appi.k_no_version")));
    var cf = st.crash_free_pct, tone = cf == null ? "" : (cf >= 99.5 ? "good" : (cf >= 98 ? "warn" : "bad"));
    k += kpi(T("appi.k_crashfree"), cf == null ? "—" : pct(cf, 2),
             cf == null ? esc(T("appi.k_crash_wait")) : esc(T("appi.k_crashes", { n: num(st.crashes), h: num(st.hangs) })),
             cf == null ? "" : esc(T("appi.k_floor")), tone);
    var med = la.median_ms != null ? la.median_ms : st.metrickit_launch_p50_ms;
    k += kpi(T("appi.k_launch"), secs(med),
             la.p90_ms != null ? esc(T("appi.k_p90", { t: secs(la.p90_ms) })) : esc(T(med == null ? "appi.k_needs_11" : "appi.k_metrickit")),
             la.measured ? esc(T("appi.k_measured", { n: num(la.measured) })) : "");
    k += kpi(T("appi.k_installs"), num(bk.install), esc(T("appi.k_updates", { u: num(bk.update), o: num(bk.open) })),
             (bk.install || bk.update || bk.open) ? "" : esc(T("appi.k_needs_11")));
    $("kpis").innerHTML = k;

    // adoption timeline
    var tl = d.timeline || { versions: [], days: [] };
    var keys = tl.versions.slice(); var hasOther = tl.days.some(function (x) { return x.share && x.share.other; });
    if (hasOther) keys.push("other");
    // colours by version number, newest first, so the newest release is always the blue one
    var byNew = tl.versions.slice().sort(function (a, b) { return vcmp(b, a); });
    var colorOf = function (v) { var i = byNew.indexOf(v); return i >= 0 ? COLORS[i % COLORS.length] : OTHER; };
    keys = byNew.concat(hasOther ? ["other"] : []);
    $("timeline").innerHTML = stacked(tl.days, keys, colorOf, function (day, v) { return (day.share || {})[v] || 0; }, function (day) {
      return day.day + " · " + num(day.sessions) + " " + T("appi.sessions") + "\n" + keys.map(function (v) { return ver(v) + ": " + pct((day.share || {})[v] || 0); }).join("\n");
    }).replace('class="appi-stack"', 'class="appi-stack appi-stack-full"');
    $("timeline-legend").innerHTML = legend(keys, colorOf, ver);
    $("adoption-lead").textContent = L
      ? T("appi.lead", { v: ver(L.version), d: L.first_seen || "—", p: pct(L.share_7d) }) + " " +
        (L.days_to_50 != null ? T("appi.lead_50", { n: days(L.days_to_50) }) + " " : "") + (L.days_to_90 != null ? T("appi.lead_90", { n: days(L.days_to_90) }) : "")
      : T("appi.k_no_version");

    // versions / OS / devices
    $("versions").innerHTML = bars(d.versions, function (r) { return ver(r.label); });
    $("os").innerHTML = bars(d.os, function (r) { return r.label === "? ?" ? T("appi.unknown") : r.label.replace(/ \?$/, ""); });
    $("devices").innerHTML = bars(d.devices, function (r) { return r.label === "?" ? T("appi.unknown") : r.label; }, 10);

    // launches
    var lh;
    if (!(bk.install || bk.update || bk.open)) lh = empty(T("appi.launch_empty"));
    else {
      var kinds = ["install", "update", "open"];
      lh = '<div class="appi-mini">' + kinds.map(function (x) {
        return '<div><span class="appi-dot" style="background:' + KIND_COLORS[x] + '"></span>' + esc(T("appi.kind_" + x)) + " <b>" + num(bk[x]) + "</b></div>";
      }).join("") + "</div>";
      lh += stacked(la.daily, kinds, function (x) { return KIND_COLORS[x]; }, function (day, x) { return day[x] || 0; }, function (day) {
        return day.day + "\n" + kinds.map(function (x) { return T("appi.kind_" + x) + ": " + num(day[x]); }).join("\n");
      });
      if (la.median_ms != null) lh += '<div class="appi-sub">' + esc(T("appi.launch_line", { m: secs(la.median_ms), p: secs(la.p90_ms), n: num(la.measured) })) + "</div>";
      if (la.per_version && la.per_version.length) {
        lh += '<table class="appi-table"><thead><tr><th>' + esc(T("appi.th_version")) + '</th><th class="r">' + esc(T("appi.th_median")) +
          '</th><th class="r">' + esc(T("appi.th_launches")) + "</th></tr></thead><tbody>" +
          la.per_version.slice(0, 5).map(function (r) {
            return "<tr><td>" + esc(ver(r.version)) + '</td><td class="r">' + secs(r.median_ms) + '</td><td class="r">' + num(r.launches) + "</td></tr>";
          }).join("") + "</tbody></table>";
      }
      if (la.updates && la.updates.length) {
        lh += '<div class="appi-sub fw-semibold mt-3">' + esc(T("appi.update_paths")) + '</div><div class="appi-paths">' + la.updates.map(function (u) {
          return '<span class="appi-path">' + esc(u.from ? ver(u.from) : T("appi.unknown")) + ' <i class="bi bi-arrow-right"></i> ' + esc(ver(u.to || "?")) + " <b>" + num(u.n) + "</b></span>";
        }).join("") + "</div>";
      }
    }
    $("launches").innerHTML = lh;

    // stability
    var sh;
    if (!st.reports) sh = empty(T("appi.stab_empty"));
    else {
      sh = '<div class="appi-mini">' +
        "<div><b>" + num(st.crashes) + "</b> " + esc(T("appi.crashes")) + "</div>" +
        "<div><b>" + num(st.hangs) + "</b> " + esc(T("appi.hangs")) + (st.hangs_per_1k != null ? ' <span class="gs-muted">(' + esc(T("appi.per_1k", { n: st.hangs_per_1k })) + ")</span>" : "") + "</div>" +
        (st.metrickit_launch_p50_ms != null ? "<div><b>" + secs(st.metrickit_launch_p50_ms) + "</b> " + esc(T("appi.mk_launch")) + "</div>" : "") +
        (st.metrickit_resume_p50_ms != null ? "<div><b>" + secs(st.metrickit_resume_p50_ms) + "</b> " + esc(T("appi.mk_resume")) + "</div>" : "") +
        "</div>";
      sh += '<div class="table-responsive"><table class="appi-table"><thead><tr><th>' + esc(T("appi.th_version")) + '</th><th class="r">' + esc(T("appi.sessions_cap")) +
        '</th><th class="r">' + esc(T("appi.crashes_cap")) + '</th><th class="r">' + esc(T("appi.hangs_cap")) + '</th><th class="r">' + esc(T("appi.th_crashfree")) + "</th></tr></thead><tbody>" +
        (st.per_version || []).map(function (r) {
          var c = r.crash_free_pct, cls = c == null ? "" : (c >= 99.5 ? "appi-good" : (c >= 98 ? "appi-warn" : "appi-bad"));
          return "<tr><td>" + esc(ver(r.version)) + '</td><td class="r">' + num(r.sessions) + '</td><td class="r">' + num(r.crashes) +
            '</td><td class="r">' + num(r.hangs) + '</td><td class="r"><span class="appi-cf ' + cls + '">' + (c == null ? "—" : pct(c, 2)) + "</span></td></tr>";
        }).join("") + "</tbody></table></div>";
    }
    $("stability").innerHTML = sh;

    if (window.bootstrap && bootstrap.Tooltip) document.querySelectorAll('[data-ai="body"] [data-bs-toggle="tooltip"]').forEach(function (el) {
      try { bootstrap.Tooltip.getOrCreateInstance(el); } catch (e) {}
    });
  }


  // ---------------------------------------------------------------- why it crashed (SDK 1.2)
  var crKind = "", crSeq = 0, crOpen = null;
  var KIND_ICON = { crash: "bi-x-octagon", hang: "bi-hourglass-split", killed: "bi-slash-circle", cpu: "bi-cpu", disk: "bi-device-hdd", launch: "bi-stopwatch" };
  function api(p) { return GS.api(p + (p.indexOf("?") < 0 ? "?" : "&") + "site=" + encodeURIComponent(GS.site)); }
  function ago(ts) {
    if (!ts) return "—";
    var t = Date.parse(String(ts).replace(" ", "T") + "Z"), d = (Date.now() - t) / 1000;
    if (!isFinite(d)) return esc(ts);
    if (d < 3600) return T("appi.cr.ago_m", { n: Math.max(1, Math.round(d / 60)) });
    if (d < 86400) return T("appi.cr.ago_h", { n: Math.round(d / 3600) });
    return T("appi.cr.ago_d", { n: Math.round(d / 86400) });
  }
  function reasonText(code, part) { var k = "appi.cr." + code + "." + part, v = T(k); return v === k ? "" : v; }

  function loadCrashes() {
    var box = $("crashes"); if (!box) return;
    var my = ++crSeq;
    api("/plugin/app-insights/crashes?from=" + cur.from + "&to=" + cur.to + (crKind ? "&kind=" + crKind : "")).then(function (r) {
      if (my !== crSeq) return;
      var d = r && r.data;
      if (!d || !d.ok) { box.innerHTML = empty(T("appi.err_p")); return; }
      if (!d.groups.length) { box.innerHTML = empty(T(crKind ? "appi.none" : "appi.cr.empty")); return; }
      box.innerHTML = '<div class="appi-crs">' + d.groups.map(function (g) {
        var expl = reasonText(g.reason, "t");
        var vers = (g.versions || []).map(function (v) { return '<span class="appi-vtag">' + esc(ver(v.version || "?")) + " · " + num(v.n) + "</span>"; }).join("");
        return '<button type="button" class="appi-cr' + (crOpen === g.signature ? " on" : "") + '" data-sig="' + esc(g.signature) + '">' +
          '<i class="bi ' + (KIND_ICON[g.kind] || "bi-x-octagon") + ' appi-cr-i appi-k-' + esc(g.kind) + '"></i>' +
          '<span class="appi-cr-main"><span class="appi-cr-t">' + esc(g.title || "—") +
          (g.platform ? ' <span class="appi-plat">' + (g.platform === "ios" ? "iOS" : "Android") + "</span>" : "") +
          (g.thread === "background" ? ' <span class="appi-plat">' + esc(T("appi.cr.bg")) + "</span>" : "") + "</span>" +
          (expl ? '<span class="appi-cr-x">' + esc(expl) + "</span>" : "") +
          (g.where ? '<code class="appi-cr-w">' + esc(g.where) + "</code>" : "") +
          '<span class="appi-cr-v">' + vers + (g.needs_symbols ? '<span class="appi-vtag appi-warnbg"><i class="bi bi-file-earmark-code"></i> ' + esc(T("appi.cr.needs_sym")) + "</span>" : "") + "</span></span>" +
          '<span class="appi-cr-n"><b>' + num(g.reports) + "</b><span>" + esc(T(g.reports === 1 ? "appi.cr.report" : "appi.cr.reports")) + "</span>" +
          '<span class="gs-muted">' + esc(ago(g.last_seen)) + "</span></span></button>";
      }).join("") + "</div>";
      box.querySelectorAll(".appi-cr").forEach(function (b) {
        b.addEventListener("click", function () { openCrash(b.getAttribute("data-sig")); });
      });
      if (crOpen) openCrash(crOpen, true);
    }).catch(function () { if (my === crSeq) box.innerHTML = empty(T("appi.err_p")); });
  }

  function openCrash(sig, keep) {
    crOpen = sig;
    document.querySelectorAll(".appi-cr").forEach(function (b) { b.classList.toggle("on", b.getAttribute("data-sig") === sig); });
    var card = $("cr-detail-card"), box = $("cr-detail"); if (!card || !box) return;
    card.hidden = false;
    if (!keep) box.innerHTML = '<div class="gs-muted small">…</div>';
    api("/plugin/app-insights/crash?sig=" + encodeURIComponent(sig) + "&from=" + cur.from + "&to=" + cur.to).then(function (r) {
      var d = r && r.data;
      if (!d || !d.ok) { box.innerHTML = empty(T("appi.err_p")); return; }
      var L = d.latest || {}, why = reasonText(d.reason, "why"), fix = reasonText(d.reason, "fix");
      var h = '<div class="appi-crd-h"><div><div class="appi-crd-t"><i class="bi ' + (KIND_ICON[d.kind] || "bi-x-octagon") + ' appi-k-' + esc(d.kind) + '"></i> ' + esc(d.title) + "</div>" +
        '<div class="gs-muted small">' + esc(T("appi.cr.d_sub", { n: num(d.reports), v: ver(L.app_version || "?"), at: L.at || "—" })) + "</div></div>" +
        '<button type="button" class="btn-close" aria-label="Close" data-ai="cr-close"></button></div>';
      if (why || fix) h += '<div class="appi-why">' + (why ? "<p><b>" + esc(T("appi.cr.why")) + "</b> " + esc(why) + "</p>" : "") +
        (fix ? "<p><b>" + esc(T("appi.cr.fix")) + "</b> " + esc(fix) + "</p>" : "") + "</div>";
      if (L.info && L.info.length) h += '<dl class="appi-kv">' + L.info.map(function (x) {
        return "<dt>" + esc(T("appi.cr.f." + x.k)) + "</dt><dd>" + esc(x.v) + "</dd>"; }).join("") + "</dl>";
      h += '<div class="appi-kv-sm">' + [L.device_model, L.os_version ? (d.platform === "ios" ? "iOS " : "Android ") + L.os_version : null, L.arch,
        L.app_build ? T("appi.cr.build", { b: L.app_build }) : null].filter(Boolean).map(esc).join(" · ") + "</div>";
      // the stack
      var frames = L.frames || [], own = frames.filter(function (f) { return f.in_app; }).length;
      h += '<div class="appi-crd-sec"><span>' + esc(T("appi.cr.stack", { t: d.thread === "main" ? T("appi.cr.main") : (d.thread === "background" ? T("appi.cr.bg") : T("appi.cr.thread")) })) + "</span>" +
        (own && own < frames.length ? '<label class="appi-sw"><input type="checkbox" data-ai="cr-all"> ' + esc(T("appi.cr.all_frames")) + "</label>" : "") + "</div>";
      if (!frames.length) h += empty(T(d.platform === "android" && d.kind === "crash" ? "appi.cr.no_frames_java" : "appi.cr.no_frames"));
      else h += '<ol class="appi-frames' + (own && own < frames.length ? " own-only" : "") + '">' + frames.map(function (f, i) {
        return '<li class="' + (f.in_app ? "own" : "sys") + (f.inlined ? " inl" : "") + '"><span class="appi-fi">' + i + "</span><code>" + esc(f.label) + "</code>" +
          (f.image && f.label.indexOf(f.image) !== 0 ? '<span class="appi-fimg">' + esc(f.image) + (f.offset ? " " + esc(f.offset) : "") + "</span>" : "") + "</li>";
      }).join("") + "</ol>";
      if (L.frames_truncated) h += '<div class="gs-muted small">' + esc(T("appi.cr.truncated")) + "</div>";
      var sy = L.symbols || {};
      if (sy.missing && sy.missing.length) h += '<div class="appi-empty appi-warnbg mt-2"><i class="bi bi-file-earmark-code"></i><span>' +
        esc(T("appi.cr.sym_missing")) + " <code>" + sy.missing.map(esc).join("</code> <code>") + "</code></span></div>";
      // spread
      var lst = function (rows) { return rows && rows.length ? rows.map(function (x) { return '<div class="appi-li"><span>' + esc(x.label === "?" ? T("appi.unknown") : x.label) + "</span><b>" + num(x.n) + "</b></div>"; }).join("") : '<div class="gs-muted small">—</div>'; };
      h += '<div class="row g-3 mt-1"><div class="col-12 col-md-4"><div class="appi-crd-sec"><span>' + esc(T("appi.versions")) + "</span></div>" + lst((d.versions || []).map(function (x) { return { label: x.label === "?" ? "?" : ver(x.label), n: x.n }; })) + "</div>" +
        '<div class="col-12 col-md-4"><div class="appi-crd-sec"><span>' + esc(T("appi.os")) + "</span></div>" + lst(d.os) + "</div>" +
        '<div class="col-12 col-md-4"><div class="appi-crd-sec"><span>' + esc(T("appi.devices")) + "</span></div>" + lst(d.devices) + "</div></div>";
      if (d.days && d.days.length > 1) h += '<div class="appi-crd-sec mt-3"><span>' + esc(T("appi.cr.per_day")) + "</span></div>" +
        stacked(d.days, ["n"], function () { return "#DC2626"; }, function (x) { return x.n; }, function (x) { return x.day + ": " + x.n; });
      box.innerHTML = h;
      var all = box.querySelector('[data-ai="cr-all"]');
      if (all) all.addEventListener("change", function () { box.querySelector(".appi-frames").classList.toggle("own-only", !all.checked); });
      box.querySelector('[data-ai="cr-close"]').addEventListener("click", function () {
        crOpen = null; card.hidden = true; document.querySelectorAll(".appi-cr").forEach(function (b) { b.classList.remove("on"); });
      });
      if (!keep) card.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }).catch(function () { box.innerHTML = empty(T("appi.err_p")); });
  }

  function wireKinds() {
    var w = $("cr-kinds"); if (!w || w._w) return; w._w = 1;
    w.querySelectorAll(".appi-pill").forEach(function (b) {
      b.addEventListener("click", function () {
        crKind = b.getAttribute("data-kind") || "";
        w.querySelectorAll(".appi-pill").forEach(function (x) { x.classList.toggle("on", x === b); });
        loadCrashes();
      });
    });
  }

  // ---------------------------------------------------------------- symbol files
  var SYM_ERR = { no_file: "appi.sym.e_no_file", too_large: "appi.sym.e_too_large", too_large_php: "appi.sym.e_too_large",
    nothing_recognised: "appi.sym.e_unknown", unknown_file: "appi.sym.e_unknown", version_required: "appi.sym.e_version",
    not_a_dsym: "appi.sym.e_unknown", no_build_id: "appi.sym.e_build_id", bad_zip: "appi.sym.e_zip", zip_not_available: "appi.sym.e_zip",
    bad_mapping: "appi.sym.e_unknown", storage_not_writable: "appi.sym.e_storage" };
  function toast(msg, tone) { if (window.GSUI && GSUI.toast) GSUI.toast(msg, tone || "success"); else alert(msg); }
  function bytes(n) { return n >= 1048576 ? (n / 1048576).toFixed(1) + " MB" : Math.max(1, Math.round(n / 1024)) + " KB"; }

  function loadSymbols() {
    var box = $("sym-files"); if (!box) return;
    api("/plugin/app-insights/symbols").then(function (r) {
      var d = r && r.data; if (!d || !d.ok) return;
      var miss = $("sym-missing");
      miss.innerHTML = d.missing && d.missing.length ? '<div class="appi-empty appi-warnbg mb-3"><i class="bi bi-file-earmark-code"></i><div>' +
        esc(T("appi.sym.missing")) + '<ul class="appi-miss">' + d.missing.map(function (m) {
          return "<li><code>" + esc(m.ident) + "</code> · " + esc(T("appi.sym.waiting", { n: num(m.reports) })) + "</li>"; }).join("") + "</ul></div></div>" : "";
      var tools = d.tools || {};
      var tl = (!tools.atos && !tools.llvm_symbolizer) ? '<div class="appi-empty mb-2"><i class="bi bi-tools"></i><span>' + esc(T("appi.sym.no_tools")) + "</span></div>" : "";
      box.innerHTML = tl + (d.files && d.files.length ? '<div class="table-responsive"><table class="appi-table"><thead><tr><th>' + esc(T("appi.sym.th_file")) +
        "</th><th>" + esc(T("appi.sym.th_kind")) + "</th><th>" + esc(T("appi.sym.th_id")) + '</th><th class="r">' + esc(T("appi.sym.th_size")) + "</th><th></th></tr></thead><tbody>" +
        d.files.map(function (f) {
          return "<tr><td>" + esc(f.name) + (f.version ? ' <span class="gs-muted">' + esc(ver(f.version)) + (f.build ? " (" + esc(f.build) + ")" : "") + "</span>" : "") +
            "</td><td>" + esc(T("appi.sym.kind_" + f.kind)) + (f.arch ? ' <span class="gs-muted">' + esc(f.arch) + "</span>" : "") +
            '</td><td><code class="appi-id">' + esc(f.ident.replace(/^[a-z0-9]+:/, "")) + '</code></td><td class="r">' + bytes(f.bytes) +
            '</td><td class="r"><button type="button" class="btn btn-link btn-sm p-0 text-danger" data-del="' + f.id + '" title="' + esc(T("appi.sym.delete")) + '"><i class="bi bi-trash"></i></button></td></tr>';
        }).join("") + "</tbody></table></div>" : '<div class="gs-muted small">' + esc(T("appi.sym.none")) + "</div>");
      box.querySelectorAll("[data-del]").forEach(function (b) {
        b.addEventListener("click", function () {
          if (!confirm(T("appi.sym.delete_q"))) return;
          GS.api("/plugin/app-insights/symboldelete?site=" + encodeURIComponent(GS.site), { method: "POST", body: JSON.stringify({ id: +b.getAttribute("data-del") }) })
            .then(function () { loadSymbols(); });
        });
      });
      var key = $("sym-key");
      var curl = "curl -H \"Authorization: Bearer " + (d.new_key || "YOUR_UPLOAD_KEY") + "\" \\\n  -F file=@dSYMs.zip \\\n  \"" + GS.apiBase + "/app/symbols?site=" + d.site_key + "\"\n\n" +
        "# Android (R8): -F file=@app/build/outputs/mapping/release/mapping.txt and &version=3.2.0&build=45";
      key.innerHTML = '<div class="d-flex gap-2 align-items-center flex-wrap mb-2"><span class="small">' +
        esc(d.key_hint ? T("appi.sym.key_has", { h: d.key_hint }) : T("appi.sym.key_none")) + '</span><button type="button" class="btn btn-sm btn-outline-secondary" data-ai="sym-newkey">' +
        esc(T(d.key_hint ? "appi.sym.key_rotate" : "appi.sym.key_make")) + "</button></div><pre class=\"appi-pre\">" + esc(curl) + "</pre>";
      key.querySelector('[data-ai="sym-newkey"]').addEventListener("click", function () {
        if (d.key_hint && !confirm(T("appi.sym.key_rotate_q"))) return;
        GS.api("/plugin/app-insights/uploadkey?site=" + encodeURIComponent(GS.site), { method: "POST", body: "{}" }).then(function (r2) {
          var k = r2 && r2.data;
          if (!k || !k.ok) { toast(T("appi.err_p"), "danger"); return; }
          d.new_key = k.key; d.key_hint = k.hint;
          key.querySelector("pre").textContent = curl.replace("YOUR_UPLOAD_KEY", k.key);
          key.querySelector(".small").textContent = T("appi.sym.key_once");
        });
      });
    });
  }

  function wireSymbols() {
    var f = $("sym-form"); if (!f || f._w) return; f._w = 1;
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var file = f.file.files[0]; if (!file) return;
      var fd = new FormData(); fd.append("file", file);
      if (f.version.value.trim()) fd.append("version", f.version.value.trim());
      if (f.build.value.trim()) fd.append("build", f.build.value.trim());
      var x = new XMLHttpRequest();
      x.open("POST", GS.apiBase + "/plugins/upload/app-insights/symbols?site=" + encodeURIComponent(GS.site));
      x.withCredentials = true;
      if (GS.csrf) x.setRequestHeader("X-CSRF-Token", GS.csrf);
      var pr = $("sym-progress"), bar = $("sym-bar"); pr.hidden = false; bar.style.width = "0%";
      x.upload.onprogress = function (ev) { if (ev.lengthComputable) bar.style.width = Math.round(ev.loaded / ev.total * 100) + "%"; };
      x.onload = function () {
        pr.hidden = true;
        var d = null; try { d = JSON.parse(x.responseText); } catch (er) {}
        if (!d || !d.ok) { toast(T(SYM_ERR[d && d.error] || "appi.sym.e_unknown") + (d && d.max_mb ? " (" + d.max_mb + " MB)" : ""), "danger"); return; }
        toast(T("appi.sym.ok", { n: d.added.length }));
        f.reset(); loadSymbols(); loadCrashes();
      };
      x.onerror = function () { pr.hidden = true; toast(T("appi.err_p"), "danger"); };
      x.send(fd);
    });
  }

  // ---------------------------------------------------------------- load
  var seq = 0;
  function load() {
    if (!window.GS || !GS.api || !GS.site || !$("body")) return;
    var site = currentSite();
    if (site && site.site_type && site.site_type !== "app") { state(T("appi.web_h"), T("appi.web_p")); return; }
    var my = ++seq;
    GS.api("/plugin/app-insights/overview?site=" + encodeURIComponent(GS.site) + "&from=" + cur.from + "&to=" + cur.to).then(function (r) {
      if (my !== seq) return;
      var d = r && r.data;
      if (!d) { state(T("appi.err_h"), T("appi.err_p")); return; }
      if (d.error === "not_for_this_site_type") { state(T("appi.web_h"), T("appi.web_p")); return; }
      if (d.error === "plugin_not_loaded") return;            // GS.pluginNotEnabled shows its panel
      if (d.gated || d.error === "not_available") { state(T("appi.plan_h"), T("appi.plan_p")); return; }
      if (!d.ok) { state(T("appi.err_h"), T("appi.err_p")); return; }
      if (!d.sessions) { state(T("appi.nodata_h"), T("appi.nodata_p")); return; }
      render(d);
      wireKinds(); wireSymbols(); loadCrashes(); loadSymbols();
    }).catch(function () { if (my === seq) state(T("appi.err_h"), T("appi.err_p")); });
  }

  function init() { wireRange(); load(); }
  if (document.readyState !== "loading") init(); else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("gs:ready", init);
  document.addEventListener("gs:site-change", load);
})();
